import { render, staticRenderFns } from "./ServiceTypeCreateEdit.vue?vue&type=template&id=d3ae280a&scoped=true"
import script from "./ServiceTypeCreateEdit.vue?vue&type=script&lang=js"
export * from "./ServiceTypeCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeCreateEdit.vue?vue&type=style&index=0&id=d3ae280a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ae280a",
  null
  
)

export default component.exports